import classNames from 'classnames/bind';
import Button from 'koba/components/Button';
import Icon from 'koba/components/Icon';
import ReactPlayer from 'react-player';
import { parseLoomId } from 'utils/urlParser';

import React from 'react';

import styles from './LinkPreview.module.scss';
import LoomPreview from './LoomPreview';

const cx = classNames.bind(styles);

interface LinkPreviewProps {
  linkUrl: string;
  onRemove: () => void;
}

const LinkPreview = ({ linkUrl, onRemove }: LinkPreviewProps) => {
  const loomId = parseLoomId(linkUrl);

  let player: React.ReactNode = null;
  if (loomId) {
    player = <LoomPreview loomId={loomId} />;
  } else {
    player = <ReactPlayer height="100%" src={linkUrl} width="100%" controls />;
  }
  return (
    <div
      aria-live="polite"
      className={cx('link-attachment__preview-container')}
      data-qa="link-attachment__preview"
      id="link-attachment-preview"
      role="region"
      title="Link Preview"
    >
      {player}
      <Button
        appearance="default"
        ariaLabel="Remove link"
        className={cx('remove-link-button')}
        onClick={onRemove}
      >
        <Icon name="x-dismiss" />
      </Button>
    </div>
  );
};

export default LinkPreview;
